import { Channel } from '../../agptesting-newview/model/channel';

export class SampleHistoryTable {
    header: string;
    channels: Channel[];
    finalresult: string;
}